
import { Popup, PopupOptions } from 'azure-maps-control';
import { FC, ReactNode, useContext, useEffect, useState } from 'react';
import {
  AzureMapsContext,
  IAzureMapPopupEvent,
  IAzureMapsContextProps
} from 'react-azure-maps';
import { createRoot } from 'react-dom/client';

import { popupDefaultOptions } from './InteractivePopup.constants';

interface InteractivePopupProps {
  children?: ReactNode;
  events?: IAzureMapPopupEvent[];
  isVisible?: boolean;
  options?: PopupOptions;
}

export const InteractivePopup: FC<InteractivePopupProps> = ({
  children = null,
  events,
  isVisible = true,
  options
}) => {
  const { mapRef } = useContext<IAzureMapsContextProps>(AzureMapsContext);
  const containerRef = document.createElement('div');
  const root = createRoot(containerRef);
  const [popupRef] = useState<Popup>(
    new Popup({
      ...popupDefaultOptions,
      ...options,
      content: containerRef
    })
  );

  useEffect(() => {
    if (mapRef) {
      events?.forEach(({ callback, eventName }) => {
        mapRef.events.add(eventName, popupRef, callback);
      });

      return () => {
        mapRef.popups.remove(popupRef);
      };
    }

    return undefined;
  }, []);

  useEffect(() => {
    root.render(children);
    popupRef.setOptions({
      ...options,
      content: containerRef
    });

    if (mapRef && isVisible && !popupRef.isOpen()) {
      popupRef.open(mapRef);
    }
  }, [options, children]);

  useEffect(() => {
    if (mapRef) {
      if (isVisible && !popupRef.isOpen()) {
        popupRef.open(mapRef);
      }

      if (mapRef.popups.getPopups().length && !isVisible && popupRef.isOpen()) {
        popupRef.close();
      }
    }
  }, [isVisible]);

  return null;
};
